import React from 'react';
import { ReactComponent as CheckboxSvg } from '../../../../assets/changeCoverage/plans/checkmark.svg';
import styles from './AddedPill.module.css';

const AddedPill = ({ text }) => (
  <div className={styles.addedPill}>
    <CheckboxSvg className={styles.checkInPill} />

    <span>{text}</span>
  </div>
);

export { AddedPill };
